import { motion } from "framer-motion";
import KorvTube from "./KorvTube";

/**
 * Editorial tonal panel — a still-life composition rendered purely
 * with type, tone and the signature product mark. Zero stock photography.
 */
export default function TonalPanel({
  bg = "bone-2",
  tubeColor = "#3a2530",
  cap = "same",
  fig = "Fig. 01",
  caption = "On surface: stone, unpolished.",
  chapter = "N° 001",
  showTube = true,
  ratio = "aspect-[3/4]",
  align = "center",
  className = "",
  sublabel = "LIP GLOSS",
}) {
  const bgClass = {
    "bone": "bg-bone",
    "bone-2": "bg-bone-2",
    "stone": "bg-stone-soft",
    "taupe": "bg-taupe",
    "plum": "bg-plum",
    "charcoal": "bg-charcoal",
    "ink": "bg-ink",
  }[bg] || "bg-bone-2";

  const isDark = bg === "plum" || bg === "charcoal" || bg === "ink";
  const inkColor = isDark ? "text-bone" : "text-ink";
  const softInk = isDark ? "text-bone/60" : "text-ink/60";

  return (
    <div className={`relative overflow-hidden ${bgClass} ${ratio} ${className}`}>
      {/* Ambient radial light */}
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background: isDark
            ? "radial-gradient(50% 50% at 50% 45%, rgba(255,255,255,0.06), transparent 65%)"
            : "radial-gradient(60% 55% at 50% 45%, rgba(255,255,255,0.25), transparent 65%)",
        }}
      />

      {/* Meta corners */}
      <div className={`absolute top-4 left-4 text-[10px] uppercase tracking-editorial ${softInk}`}>
        {chapter}
      </div>
      <div className={`absolute top-4 right-4 text-[10px] uppercase tracking-editorial ${softInk}`}>
        korv.
      </div>

      {showTube && (
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.4, ease: [0.2, 0.7, 0.1, 1] }}
          className={`absolute inset-0 flex ${align === "center" ? "items-center justify-center" : "items-end justify-center pb-16"}`}
        >
          <KorvTube
            color={tubeColor}
            cap={cap}
            sublabel={sublabel}
            animate={false}
            className="h-[68%] w-auto drop-shadow-[0_30px_35px_rgba(20,18,17,0.28)]"
          />
        </motion.div>
      )}

      {/* Caption */}
      <div className={`absolute inset-x-4 bottom-4 flex items-end justify-between text-[10px] uppercase tracking-editorial ${softInk}`}>
        <span>{fig}</span>
        <span className="max-w-[60%] text-right normal-case tracking-normal">{caption}</span>
      </div>
    </div>
  );
}
